// extracted by mini-css-extract-plugin
module.exports = {"secondaryMenuHeader":"_1Kpb8","secondaryTitle":"_1b6KE","menuItemBigChevron":"_231oY"};